import React from 'react';
import { IconType } from 'react-icons';
import GoldIcon from '../Svg/gold-icon';
interface DividerProps {
  icon: IconType;
}
const Divider: React.FC<DividerProps> = ({
  icon: Icon
}) => {
  return <div className="flex items-center justify-center my-12 max-w-3xl mx-auto" data-sentry-component="Divider" data-sentry-source-file="divider.tsx">
      <div className="flex-grow border-t border-neutral-300 dark:border-neutral-700"></div>
      <span className="mx-4 text-white dark:text-neutral-100 bg-neutral-100 dark:bg-neutral-800 rounded-full p-2">
      <GoldIcon style={{
        width: '24px',
        height: '24px'
      }} data-sentry-element="GoldIcon" data-sentry-source-file="divider.tsx" />
      </span>
      <div className="flex-grow border-t border-neutral-300 dark:border-neutral-700"></div>
    </div>;
};
export default Divider;